import { createSlice } from '@reduxjs/toolkit'
import { isOnlyLetters } from '@skytech/utils'

import { postCustomerAPI } from '@/api/customersApi'
import { getErrorCode } from '@/util/request'

import { fetchCustomers } from './customersReducer'

export const NAME = 'new-customer'

export const createNewCustomer = ({
  id,
  name,
  orgNumber,
  vatNumber,
  customerHeadId = 0,
  customerHeadName,
  streetAddress = {},
  billingAddress = {},
  contactPerson = {},
  numberOfEmployees,
}: any) => ({
  id,
  name,
  orgNumber,
  vatNumber,
  customerHeadId,
  customerHeadName,
  streetAddress,
  billingAddress,
  contactPerson,
  numberOfEmployees,
})
// @ts-ignore
export const publishCustomer = () => async (dispatch, getState) => {
  const isPending = getIsPostPending(getState())

  if (isPending) return

  dispatch(postPending())

  const editCustomer = getEditCustomer(getState())

  try {
    const result = await postCustomerAPI(editCustomer)

    dispatch(postSuccess(result))
    dispatch(fetchCustomers())
  } catch (error) {
    dispatch(
      postFailure(
        getErrorCode(error) === 409
          ? `Customer with supplied org number already exists`
          : 'Could not save customer'
      )
    )
  }
}

const initialState = {
  postPending: false,
  postError: undefined,
  postSuccess: false,
  editCustomer: createNewCustomer({}),
  newCusomerId: undefined,
}

const { actions, reducer } = createSlice({
  name: NAME,
  initialState,
  reducers: {
    setEditProp: (state, { payload }) => {
      const { prop, value } = payload
      state.editCustomer = {
        ...state.editCustomer,
        [prop]: value,
      }
    },
    postPending: state => {
      state.postPending = true
      state.postError = undefined
      state.postSuccess = false
    },
    postSuccess: (state, { payload: customer }) => {
      state.postPending = false
      state.postSuccess = true
      state.editCustomer = customer
    },
    postFailure: (state, { payload: error }) => {
      state.postPending = false
      state.postError = error
      state.postSuccess = false
    },
    reset: () => ({
      ...initialState,
    }),
  },
})

export const { postPending, postSuccess, postFailure, setEditProp, reset } = actions
export default reducer

const getState = (state: any) => state[NAME]

export const getIsPostPending = (state: any) => getState(state).postPending
export const getPostError = (state: any) => getState(state).postError
export const getIsPosted = (state: any) => getState(state).postSuccess

export const getEditCustomer = (state: any) => getState(state).editCustomer

// @ts-ignore
export const getEditProp = (state, prop) => getEditCustomer(state)[prop]
// @ts-ignore
export const getEditIsValid = (state, isBechtle) =>
  isBechtle ? getIsValidBechtle(state) : getIsValidDefault(state)

const getIsValidDefault = (state: any) =>
  Boolean(getEditProp(state, 'name')) &&
  Boolean(getEditProp(state, 'streetAddress')?.city) &&
  isOnlyLetters(getEditProp(state, 'streetAddress')?.city) &&
  isOnlyLetters(getEditProp(state, 'billingAddress')?.city) &&
  Boolean(getEditProp(state, 'billingAddress')?.city) &&
  Boolean(getEditProp(state, 'orgNumber'))

const getIsValidBechtle = (state: any) =>
  Boolean(getEditProp(state, 'name')) &&
  Boolean(getEditProp(state, 'streetAddress')?.city) &&
  isOnlyLetters(getEditProp(state, 'streetAddress')?.city) &&
  Boolean(getEditProp(state, 'contactPerson')?.name) &&
  Boolean(getEditProp(state, 'contactPerson')?.phone) &&
  Boolean(getEditProp(state, 'contactPerson')?.email) &&
  Boolean(getEditProp(state, 'orgNumber')) &&
  Boolean(getEditProp(state, 'numberOfEmployees')) &&
  Boolean(getEditProp(state, 'vatNumber'))

export const getStreetAdr = (state: any) => getState(state).streetAddress
export const getBillingAdr = (state: any) => getState(state).billingAddress
